import { render, staticRenderFns } from "./FractionalDepositFeatureSettings.vue?vue&type=template&id=f196d94e"
import script from "./FractionalDepositFeatureSettings.vue?vue&type=script&lang=js"
export * from "./FractionalDepositFeatureSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports